webpackJsonp([203542839793359],{

/***/ 937:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/anti-harlem-shake"},"excerpt":"Devenir fan :  http://www.facebook.com/PofMagicfingersFans \nTwitter :  http://twitter.com/pofmagicfingers","timeToRead":1,"frontmatter":{"title":"ANTI Harlem Shake","tags":["PofMagicfingers","youtube","video","Pof","Magicfingers","Pof Magicfingers","Harlem Shake","Original","Remix","Anti","Anti Harlem","Shake","Anti Harlem Shake","Harlem","Anti HS","Inverse"],"cover":null,"date":"2013-03-07T07:00:43.000Z"}}}]}},"pathContext":{"tag":"Remix"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-remix-259cfdff565e6399bf2c.js